import { ApplicationContext } from '../application-context.model';
import { SourceSheet } from './source-sheet';

export interface RefreshStatusRequestDto extends ApplicationContext {
  Sheets: SourceSheet[];
}

export interface RefreshStatusDto {
  SourceSheet: string;
  LastRefreshed: string | null;
  HasNewData: boolean;
}

export interface RefreshStatusResponseDto {
  Success: boolean;
  Value: string;
  Data: RefreshStatusDto[] | null;
}

export enum RefreshState {
  New = 'new',
  Updated = 'updated',
  None = 'none',
}

export const iconClassMap: Record<RefreshState, string> = {
  [RefreshState.New]: 'ph-info',
  [RefreshState.Updated]: 'ph-check-circle',
  [RefreshState.None]: 'ph-question',
};

export const buttonTextMap: Record<RefreshState, string> = {
  [RefreshState.New]: 'Refresh',
  [RefreshState.Updated]: 'Load',
  [RefreshState.None]: 'Load',
};

export const statusLabelMap: Record<RefreshState, string> = {
  [RefreshState.New]: 'New Data Available',
  [RefreshState.Updated]: 'Updated: ',
  [RefreshState.None]: 'No Data Loaded',
};
